import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import Datatype from './Datatype';
import ReifyButton from './ReifyButton';
import { globalStyles as styles } from './style/gstheme';
import { DATATYPES } from './utils/constants';

class DateField extends React.Component {

    handleDelete = () => {
        this.props.onDelete(this.props.date);
    };

    render() {

        const { classes, isReadOnly, date, invalidDatatype, displayDatatype, reify, onReify,
            source, property, graph, applicableStatements, onDelete } = this.props;
        const m = new Date(date);
        const displayText =
            m.getUTCFullYear() + "/" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) + "/" +
            ("0" + m.getUTCDate()).slice(-2);

        return (
            <div style={{ display: 'flex' }} data-test="date-container">
                {reify &&
                    <ReifyButton
                        subject={source}
                        property={property}
                        isReadOnly={isReadOnly}
                        graph={graph}
                        value={{
                            "@value": date,
                            "type": "http://www.w3.org/2001/XMLSchema#date"
                        }}
                        applicableStatements={applicableStatements}
                        onReify={onReify} />
                }
                <TextField
                    data-test="date"
                    value={displayText}
                    variant="outlined"
                    margin="dense"
                    style={{ marginTop: 0 }}
                    fullWidth
                    helperText={invalidDatatype ? <span data-test="helper-text">This value is no longer valid for the property's datatype.</span> : ""}
                    InputProps={{
                        className: classes.inputLabel,
                        startAdornment: displayDatatype ? <Datatype datatype={DATATYPES.DATE} invalid={invalidDatatype} /> : null,
                        endAdornment: !isReadOnly && onDelete &&
                            <InputAdornment position="end" onClick={this.handleDelete}>
                                <IconButton aria-label="Delete date" size="small">
                                    <DeleteIcon data-test="delete-date" fontSize="small" />
                                </IconButton>
                            </InputAdornment>,
                        inputProps: {
                            "data-test": "date-value",
                            readOnly: true,
                            maxLength: this.props.maxLength
                        }
                    }}
                />
            </div>
        );
    }
}

DateField.defaultProps = {
    isReadOnly: false,
    invalidDatatype: false,
    displayDatatype: true
};

DateField.propTypes = {
    isReadOnly: PropTypes.bool,
    invalidDatatype: PropTypes.bool,
    onUpdate: PropTypes.func,
    maxLength: PropTypes.number,
    onDelete: PropTypes.func,
    displayDatatype: PropTypes.bool,
    date: PropTypes.string.isRequired,
    graph: PropTypes.string,
    reify: PropTypes.bool,
    onReify: PropTypes.func,
    source: PropTypes.string,
    property: PropTypes.string,
    applicableStatements: PropTypes.array,
    classes: PropTypes.object
};

export default withStyles(styles)(DateField);